<app-modal-shell [config]="modalConfig">
  <div modal-content class="about-dialog">
    <p class="about-dialog__description">
      INA Comunidades integra la gestión de comunidades, miembros, servicios divinos,
      concurrencia de INASud.
    </p>

    <dl class="about-dialog__versions">
      <div class="about-dialog__version-row">
        <dt>
          <mat-icon>verified</mat-icon>
          Versión
        </dt>
        <dd>{{ appVersion() }}</dd>
      </div>
    </dl>
  </div>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="close()">Cerrar</button>
  </ng-container>
</app-modal-shell>
